module.exports = __webpack_public_path__ + "img/10024.18c4f672.png";